import { AlertTriangle, TrendingUp, TrendingDown, Flame, Snowflake, Shuffle } from 'lucide-react';

const regimeConfig = {
  CRISIS: { icon: AlertTriangle, color: 'bg-regime-crisis', text: 'CRISIS', desc: 'High VIX, gold up, risk assets down' },
  'RISK-ON': { icon: TrendingUp, color: 'bg-regime-risk-on', text: 'RISK-ON', desc: 'Low VIX, equities up, USD weak' },
  'RISK-OFF': { icon: TrendingDown, color: 'bg-regime-risk-off', text: 'RISK-OFF', desc: 'Rising VIX, bonds up, equities flat/down' },
  INFLATIONARY: { icon: Flame, color: 'bg-regime-inflationary', text: 'INFLATIONARY', desc: 'Oil up, gold up, yields rising' },
  DEFLATIONARY: { icon: Snowflake, color: 'bg-regime-deflationary', text: 'DEFLATIONARY', desc: 'Oil down, yields falling, USD strong' },
  TRANSITIONAL: { icon: Shuffle, color: 'bg-regime-transitional', text: 'TRANSITIONAL', desc: 'Mixed signals, regime changing' },
};

export default function RegimeBanner() {
  // TODO: Replace with useRegime() hook connected to backend
  const regime = 'TRANSITIONAL';
  const confidence = 0;
  const config = regimeConfig[regime] || regimeConfig.TRANSITIONAL;
  const Icon = config.icon;

  return (
    <div className={`${config.color} bg-opacity-15 border-b border-korinth-border`}>
      <div className="flex items-center justify-between px-4 py-1.5">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4" />
          <span className="text-xs font-mono font-bold tracking-wider">{config.text}</span>
          <span className="text-xs text-korinth-muted">— {config.desc}</span>
        </div>
        <div className="text-xs font-mono text-korinth-muted">
          Confidence: {confidence > 0 ? `${confidence}%` : 'Awaiting data...'}
        </div>
      </div>
    </div>
  );
}
